import { useState } from "react";
import { StarFilled } from "@ant-design/icons";
import { Button, Input, message, Modal, Rate, Tooltip } from "antd";
import { getRating, hasRated, saveRating } from "src/utils/ratingStorage";

const rateLabels: Record<number, string> = {
  1: "Juda yomon",
  2: "Yomon",
  3: "Qoniqarli",
  4: "Yaxshi",
  5: "A'lo",
};

export function RatingWidget() {
  const [open, setOpen] = useState(false);
  const [rating, setRating] = useState<number>(() => getRating()?.rating ?? 0);
  const [comment, setComment] = useState<string>(() => getRating()?.comment ?? "");
  const [submitted, setSubmitted] = useState(hasRated);

  const handleOpen = () => {
    const saved = getRating();
    if (saved) {
      setRating(saved.rating);
      setComment(saved.comment);
    }
    setOpen(true);
  };

  const handleSubmit = () => {
    if (!rating) {
      void message.warning("Iltimos, baholang");
      return;
    }
    saveRating({ rating, comment, source: "client" });
    setSubmitted(true);
    setOpen(false);
    void message.success(`Bahoyingiz qabul qilindi! Siz ${rating} yulduz berdingiz`);
  };

  return (
    <>
      <Tooltip title={submitted ? "Bahoingizni ko'rish / o'zgartirish" : "Tizimni baholang"}>
        <Button
          type="text"
          icon={
            <StarFilled
              style={submitted ? { color: "#6366f1" } : { color: "var(--color_text, #555)" }}
            />
          }
          onClick={handleOpen}
        />
      </Tooltip>

      <Modal
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        title={
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <StarFilled style={{ color: "#6366f1" }} />
            <span>Tizimni baholang</span>
          </div>
        }
        centered
        width={420}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 16,
            padding: "16px 0",
          }}
        >
          <p style={{ margin: 0, color: "#888", textAlign: "center", fontSize: 14 }}>
            Tizim sifati haqida fikringizni bildiring
          </p>

          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 4 }}>
            <Rate value={rating} onChange={setRating} style={{ fontSize: 36 }} />
            {rating > 0 && (
              <span style={{ fontSize: 13, fontWeight: 500, color: "#6366f1" }}>
                {rateLabels[rating]}
              </span>
            )}
          </div>

          <Input.TextArea
            placeholder="Izoh (ixtiyoriy)"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            rows={3}
            maxLength={300}
            showCount
            style={{ width: "100%" }}
          />

          <div style={{ display: "flex", gap: 8, width: "100%", justifyContent: "flex-end" }}>
            <Button onClick={() => setOpen(false)}>Bekor qilish</Button>
            <Button type="primary" onClick={handleSubmit} disabled={!rating}>
              Yuborish
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
}
